export default {
  name: 'Listagem de Cadastros',
  children: [
    {
      name: 'Trabalhadores',
      children: [
        {
          name: 'Contratados',
          value: 'trabalhador',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Situação de Contratados',
          value: 'trabalhador-situacao',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDatePeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Trabalhadores em Experiência',
          value: 'trabalhador-experiencia',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDatePeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Sócios',
          value: 'diretor',
          options: {
            showJobDescriptionSelect: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Estagiários',
          value: 'INTERN_LIST',
        },
        {
          name: 'Dependentes',
          value: 'dependente',
        },
        {
          name: 'Relação de Aniversariantes',
          value: 'trabalhador-aniversario',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDatePeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Admitidos e Demitidos',
          value: 'trabalhador-admi-demi',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDatePeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Listagem de Demitidos',
          value: 'trabalhador-demitido',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showGroupBy: true,
          },
        },
      ],
    },
    {
      name: 'Empresas',
      value: 'empresa',
    },
    {
      name: 'Estabelecimentos',
      value: 'estabelecimento',
    },
    {
      name: 'Lotações',
      value: 'lotacao',
    },
    {
      name: 'Sindicatos',
      value: 'sindicato',
    },
    {
      name: 'Eventos',
      value: 'evento',
    },
    {
      name: 'Turnos/Horários',
      value: 'turno',
    },
  ],
};
